export default "__VITE_ASSET__DsuqrzpY__"